import { render, staticRenderFns } from "./OnboardingChecklist.vue?vue&type=template&id=00425267&scoped=true&"
import script from "./OnboardingChecklist.vue?vue&type=script&lang=js&"
export * from "./OnboardingChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00425267",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00425267')) {
      api.createRecord('00425267', component.options)
    } else {
      api.reload('00425267', component.options)
    }
    module.hot.accept("./OnboardingChecklist.vue?vue&type=template&id=00425267&scoped=true&", function () {
      api.rerender('00425267', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Onboarding/OnboardingChecklist.vue"
export default component.exports